// Product data files live in the $web Azure Blob Storage container under /data/.
//
// In all environments the frontend uses relative paths (/data/...).
//   - Azure (dev/prod): the SPA is served from the static website endpoint of the same
//     storage account, so /data/... resolves to $web/data/... automatically.
//   - Local dev: src/setupProxy.js forwards /data/* from the CRA dev server (port 3001)
//     to the local Azurite emulator (port 10000), rewriting the path to include
//     /devstoreaccount1/$web/data/.... No env var or CORS config needed.

// Stable timestamp per dev-server session — changes on every `npm start`.
// Used to bust the browser disk cache for images in development.
const SESSION_TS = Date.now();

/**
 * Resolves a storage-relative path. Currently a pass-through; kept as a
 * centralised hook in case the URL scheme needs to change in future.
 * path must start with '/', e.g. '/data/products/images/foo.jpg'
 *
 * In development, appends ?_t=<session-timestamp> so browsers never serve
 * images from disk cache across dev-server restarts.
 */
export function resolveStorageUrl(path: string): string {
  // Collapse any accidental double slashes (e.g. "/data/products/images//foo.jpg"
  // when the image field stored in the DB already has a leading "/").
  const normalized = path.replace(/\/\/+/g, '/');
  if (process.env.NODE_ENV === 'development') {
    return `${normalized}?_t=${SESSION_TS}`;
  }
  return normalized;
}
